import createSubmit from '../../Form/createSubmitButton.jsx'
import { name } from './ForgottenPasswordForm.jsx'

export default createSubmit(name)